module.exports = __webpack_public_path__ + "media/julio_feature_zoom_out_anim.15c035a5.mp4";